/* eslint-disable @typescript-eslint/no-explicit-any */
import { GridColDef } from "@mui/x-data-grid";
import DeleteIcon from "@mui/icons-material/Delete";

import { Button } from "@mui/material";
import {
  EmailIgnoreList,
  IgnoreList,
  IndividualIgnoreList,
  LocationIgnoreList,
  NationalInsuranceIgnoreList,
  PhoneIgnoreList,
  VehicleIgnoreList,
  VehicleCreditHireClientIgnoreList,
} from "./types";

// Email columns
export const getEmailColumns = ({
  onDelete,
}: {
  onDelete: (row: EmailIgnoreList) => void;
}): GridColDef[] => [
  {
    field: "id",
    headerName: "ID",
    width: 80,
  },
  {
    field: "emailAddress",
    headerName: "Email Address",
    flex: 1,
  },
  {
    field: "actions",
    type: "actions",
    headerName: "Actions",
    align: "right",
    getActions: ({ row }: { row: EmailIgnoreList }) => [
      <Button
        key="delete"
        onClick={(e: any) => {
          e.stopPropagation();
          onDelete(row);
        }}
      >
        <DeleteIcon fontSize="small" />
      </Button>,
    ],
  },
];

// Individual columns
export const getIndividualColumns = ({
  onDelete,
}: {
  onDelete: (row: IndividualIgnoreList) => void;
}): GridColDef[] => [
  {
    field: "id",
    headerName: "ID",
    width: 80,
  },
  {
    field: "providedName",
    headerName: "Name",
    flex: 1,
  },
  {
    field: "actions",
    type: "actions",
    headerName: "Actions",
    align: "right",
    getActions: ({ row }: { row: IndividualIgnoreList }) => [
      <Button
        key="delete"
        onClick={(e: any) => {
          e.stopPropagation();
          onDelete(row);
        }}
      >
        <DeleteIcon fontSize="small" />
      </Button>,
    ],
  },
];

// Location columns
export const getLocationColumns = ({
  onDelete,
}: {
  onDelete: (row: LocationIgnoreList) => void;
}): GridColDef[] => [
  {
    field: "id",
    headerName: "ID",
    width: 80,
  },
  {
    field: "fullAddress",
    headerName: "Full Address",
    flex: 1,
  },
  {
    field: "pafudprn",
    headerName: "PAFUDPRN",
    width: 150,
  },
  {
    field: "actions",
    type: "actions",
    headerName: "Actions",
    align: "right",
    getActions: ({ row }: { row: LocationIgnoreList }) => [
      <Button
        key="delete"
        onClick={(e: any) => {
          e.stopPropagation();
          onDelete(row);
        }}
      >
        <DeleteIcon fontSize="small" />
      </Button>,
    ],
  },
];

// National Insurance columns
export const getNationalInsuranceColumns = ({
  onDelete,
}: {
  onDelete: (row: NationalInsuranceIgnoreList) => void;
}): GridColDef[] => [
  {
    field: "id",
    headerName: "ID",
    width: 80,
  },
  {
    field: "nationalInsuranceNumber",
    headerName: "National Insurance Number",
    flex: 1,
  },
  {
    field: "actions",
    type: "actions",
    headerName: "Actions",
    align: "right",
    getActions: ({ row }: { row: NationalInsuranceIgnoreList }) => [
      <Button
        key="delete"
        onClick={(e: any) => {
          e.stopPropagation();
          onDelete(row);
        }}
      >
        <DeleteIcon fontSize="small" />
      </Button>,
    ],
  },
];

// Phone columns
export const getPhoneColumns = ({
  onDelete,
}: {
  onDelete: (row: PhoneIgnoreList) => void;
}): GridColDef[] => [
  {
    field: "id",
    headerName: "ID",
    width: 80,
  },
  {
    field: "phoneNumber",
    headerName: "Phone Number",
    flex: 1,
  },
  {
    field: "actions",
    type: "actions",
    headerName: "Actions",
    align: "right",
    getActions: ({ row }: { row: PhoneIgnoreList }) => [
      <Button
        key="delete"
        onClick={(e: any) => {
          e.stopPropagation();
          onDelete(row);
        }}
      >
        <DeleteIcon fontSize="small" />
      </Button>,
    ],
  },
];

// Vehicle columns
export const getVehicleColumns = ({
  onDelete,
}: {
  onDelete: (row: VehicleIgnoreList) => void;
}): GridColDef[] => [
  {
    field: "id",
    headerName: "ID",
    width: 80,
  },
  {
    field: "registrationNumber",
    headerName: "Registration Number",
    flex: 1,
  },
  {
    field: "actions",
    type: "actions",
    headerName: "Actions",
    align: "right",
    getActions: ({ row }: { row: VehicleIgnoreList }) => [
      <Button
        key="delete"
        onClick={(e: any) => {
          e.stopPropagation();
          onDelete(row);
        }}
      >
        <DeleteIcon fontSize="small" />
      </Button>,
    ],
  },
];

// Vehicle Credit Hire Client columns
export const getVehicleCreditHireClientColumns = ({
  onDelete,
}: {
  onDelete: (row: VehicleCreditHireClientIgnoreList) => void;
}): GridColDef[] => [
  {
    field: "clientId",
    headerName: "Client ID",
    flex: 1,
  },
  {
    field: "actions",
    type: "actions",
    headerName: "Actions",
    align: "right",
    getActions: ({ row }: { row: VehicleCreditHireClientIgnoreList }) => [
      <Button
        key="delete"
        onClick={(e: any) => {
          e.stopPropagation();
          onDelete(row);
        }}
      >
        <DeleteIcon fontSize="small" />
      </Button>,
    ],
  },
];

// Vehicle Credit Hire Client columns
export const getDefaultColumns = ({
  onDelete,
}: {
  onDelete: (row: IgnoreList) => void;
}): GridColDef[] => [
  {
    field: "id",
    headerName: "ID",
    width: 120,
  },
  {
    field: "actions",
    type: "actions",
    headerName: "Actions",
    align: "right",
    getActions: ({ row }: { row: IgnoreList }) => [
      <Button
        key="delete"
        onClick={(e: any) => {
          e.stopPropagation();
          onDelete(row);
        }}
      >
        <DeleteIcon fontSize="small" />
      </Button>,
    ],
  },
];

// Generic columns for all entity types
const getColumns = ({
  entityType,
  onDelete,
}: {
  entityType: string;
  onDelete: (row: IgnoreList) => void;
}): GridColDef[] => {
  switch (entityType) {
    case "emails":
      return getEmailColumns({ onDelete });
    case "individuals":
      return getIndividualColumns({ onDelete });
    case "locations":
      return getLocationColumns({ onDelete });
    case "nationalInsurances":
      return getNationalInsuranceColumns({ onDelete });
    case "phones":
      return getPhoneColumns({ onDelete });
    case "vehicles":
      return getVehicleColumns({ onDelete });
    case "vehicleCreditHireClientIds":
      return getVehicleCreditHireClientColumns({ onDelete });
    default:
      return getDefaultColumns({ onDelete });
  }
};

export default getColumns;
